import React, { useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { MdDashboard } from "react-icons/md";
import { MdOutlineCategory } from "react-icons/md";
import { MdOutlineProductionQuantityLimits } from "react-icons/md";
import { CiLogout } from "react-icons/ci";
import { IoIosPeople } from "react-icons/io";
import { useRole } from "../../../Routing/Routing";
import { TfiLayoutSlider } from "react-icons/tfi";
import { FaGift } from "react-icons/fa";
import { CgDisplayGrid } from "react-icons/cg";
import { IoMdSettings } from "react-icons/io";
import { MdAssignmentInd } from "react-icons/md";
import { FaCartArrowDown } from "react-icons/fa";
import { BiSolidPurchaseTag } from "react-icons/bi";
import { FaPeopleArrows } from "react-icons/fa6";
import { AiFillNotification } from "react-icons/ai";
import { MdManageHistory } from "react-icons/md";
import { SiPostman } from "react-icons/si";
import { FaParachuteBox } from "react-icons/fa";
import { TbPasswordMobilePhone } from "react-icons/tb";
import { TbReport } from "react-icons/tb";
import { RiDragDropFill } from "react-icons/ri";
function SlideBar({ activeClass, onToggle }) {

    const { access } = useRole();
    const location = useLocation();

    const ulRef = useRef(null); // Reference for the nav container
    const activeRef = useRef(null);

    const nav = useNavigate();
    const handleLogOut = () => {
        sessionStorage.removeItem('tokenKey');
        nav('/admin');
        window.location.reload();
    };

    // Function to determine if a menu item should be active
    const isActive = (path) => location.pathname === path;

    const pageList = [
        {
            path: '/admin/dash',
            title: 'Dashboard',
            icon: <MdDashboard />,
            module: 'dashboard',
        },
        {
            path: '/admin/banner',
            title: 'Banner',
            icon: <TfiLayoutSlider />,
            module: 'banner',
        },
        {
            path: '/admin/cart',
            title: 'Cart',
            icon: <FaCartArrowDown />,
            module: 'cart',
        },
        {
            path: '/admin/order',
            title: 'Order',
            icon: <BiSolidPurchaseTag />,
            module: 'order',
        },
        {
            path: "/admin/report",
            title: "Report",
            icon: <TbReport />,
            module: "report",
        },
        {
            path: '/admin/customer',
            title: 'Customer',
            icon: <FaPeopleArrows />,
            module: 'customer'
        },
        {
            path: '/admin/notify',
            title: 'Notify Me Items',
            icon: <AiFillNotification />,
            module: 'notify_me_items'
        },
        {
            path: '/admin/category',
            title: 'Category',
            icon: <MdOutlineCategory />,
            module: 'category',
        },
        {
            path: '/admin/sequence',
            title: 'Sequence',
            icon: <RiDragDropFill />,
            module: 'category',
        },
        {
            path: '/admin/item',
            title: 'Item',
            icon: <MdOutlineProductionQuantityLimits />,
            module: 'item',
        },
        {
            path: "/admin/publisher",
            title: 'Publisher',
            icon: <SiPostman />,
            module: "publisher",
        },
        {
            path: '/admin/displayCat',
            title: "Display Category",
            icon: <CgDisplayGrid />,
            module: "display_category",
        },
        {
            path: '/admin/courier',
            title: "Courier",
            icon: <FaParachuteBox />,
            module: "courier",
        },
        {
            path: '/admin/otps',
            title: "OTP",
            icon: <TbPasswordMobilePhone />,
            module: "order",
        },
        {
            path: '/admin/staff',
            title: 'Staff',
            icon: <IoIosPeople />,
            module: 'staff',
        },
        {
            path: '/admin/gift',
            title: 'Coupon',
            icon: < FaGift />,
            module: 'coupon',
        },
        {
            path: '/admin/managePage',
            title: 'Manage Pages',
            icon: < MdAssignmentInd />,
            module: 'manage_pages',
        },
        {
            path: '/admin/setting',
            title: 'Setting',
            icon: <IoMdSettings />,
            module: 'setting'
        },
        {
            path: '/admin/cms',
            title: 'Cms',
            icon: <MdManageHistory />,
            module: 'cms'
        }
    ];

    useEffect(() => {
        if (activeRef.current) {
            activeRef.current.scrollIntoView({
                behavior: "smooth",
                block: "center",
            });
        }
    }, [location.pathname]);

    const removeSomeSession = () => {
        sessionStorage.removeItem("sortFilterOFItem");
        sessionStorage.removeItem("scrollPosition");
        sessionStorage.setItem("currentPage", 1);
        sessionStorage.removeItem("itemSearch");
        sessionStorage.removeItem("filterByCategory");
        sessionStorage.removeItem("filterByPublisher");
    };

    return (
        <>
            <div className={activeClass ? "active main" : "main"}>
                <nav className={activeClass ? "active" : ""}>
                    <ul ref={ulRef}>
                        <li>
                            {/* Conditionally render based on the "active" state */}
                            {
                                activeClass ? (
                                    <div className="admin">
                                        <h1>TheBooks24</h1>
                                    </div>
                                ) : (
                                    <div className="admin-inactive">
                                        <h1>TB2</h1>
                                    </div>
                                )}
                        </li>

                        {
                            pageList.map((itm) => {
                                return (
                                    <>
                                        <div>
                                            {
                                                access?.responsePacket?.some((item) => item.moduleDetail.parentTitle === itm.module) && (
                                                    <li className={isActive(itm.path) ? 'active-menu' : ""} ref={isActive(itm.path) ? activeRef : null} onClick={removeSomeSession}>
                                                        <Link to={itm.path} onClick={onToggle} className="d-flex ali-itm">
                                                            <span className="icon">{itm.icon}</span>
                                                            <span className="title">{itm.title}</span>
                                                            {itm.cartTotal && <span className="icon">{itm.cartTotal}</span>}
                                                        </Link>
                                                    </li>
                                                )
                                            }
                                        </div>
                                    </>
                                )
                            })
                        }

                        <li>
                            <Link onClick={handleLogOut}>
                                <span className="icon"><CiLogout /></span>
                                <span className="title">Sign Out</span>
                            </Link>
                        </li>
                    </ul>
                </nav>
            </div>
        </>
    );
}

export { SlideBar };